import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'accountActionIcon'
})
export class AccountActionIconPipe implements PipeTransform {
    private readonly iconMap: Record<string, string> = {
        ACCOUNT_ACTION_EDIT: 'pencil',
        ACCOUNT_ACTION_CHANGE_PASSWORD: 'key',
        ACCOUNT_ACTION_CHANGE_EMAIL: 'email',
        ACCOUNT_ACTION_DELETE_ACCOUNT: 'trash-bin'
    };

    transform(action: string): string | null {
        return this.iconMap[action] || null;
    }
}
